export class PreventivoFase1DTO {
    
    preventivo!:number;
    note!:string;
  }
  